import _extends from "@babel/runtime/helpers/extends";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["value", "options", "open", "placeholder", "autoFocus", "size", "width", "minWidth", "maxWidth", "name", "onChange", "allOption", "disabled", "title"];
import * as React from 'react';
import cx from 'classnames';
import { useForkRef } from '@cian/react-utils';
import { InputWrapper } from '../../../../internal/components/InputWrapper';
import { HiddenInput } from '../../../../internal/components/HiddenInput';
import { ArrowDownS16, ArrowUpS16 } from '../../../../icons';
import { InputAdornment } from '../../../../inputAdornment';
import * as styles from './styles.css';
export var SelectInput = /*#__PURE__*/React.forwardRef(function SelectInput(props, ref) {
  var value = props.value,
    options = props.options,
    open = props.open,
    placeholder = props.placeholder,
    autoFocus = props.autoFocus,
    size = props.size,
    width = props.width,
    minWidth = props.minWidth,
    maxWidth = props.maxWidth,
    name = props.name,
    onChange = props.onChange,
    allOption = props.allOption,
    disabled = props.disabled,
    title = props.title,
    divProps = _objectWithoutProperties(props, _excluded);
  var _React$useState = React.useState(null),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    displayNode = _React$useState2[0],
    setDisplayNode = _React$useState2[1];
  var inputRef = useForkRef(setDisplayNode, ref);
  var label = React.useMemo(function () {
    if (!hasValue(value)) {
      return null;
    }
    var valueArray = Array.isArray(value) ? value : [value];
    return options.reduce(function (result, option) {
      if (valueArray.includes(option.value)) {
        result.push(option.label || option.value);
      }
      return result;
    }, []).join(', ');
  }, [options, value]);
  React.useEffect(function () {
    if (displayNode && autoFocus && !disabled) {
      displayNode.focus();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [displayNode, autoFocus]);
  return /*#__PURE__*/React.createElement(InputWrapper, _extends({}, divProps, {
    ref: inputRef,
    size: size,
    width: width,
    minWidth: minWidth,
    maxWidth: maxWidth,
    cursor: "pointer",
    tabIndex: divProps.tabIndex || 0,
    disabled: disabled,
    rightAdornment: /*#__PURE__*/React.createElement(InputAdornment, null, /*#__PURE__*/React.createElement("div", {
      className: cx(styles['arrow'], disabled && styles['disabled'])
    }, open ? /*#__PURE__*/React.createElement(ArrowUpS16, {
      color: "current_color"
    }) : /*#__PURE__*/React.createElement(ArrowDownS16, {
      color: "current_color"
    })))
  }), /*#__PURE__*/React.createElement(HiddenInput, {
    defaultValue: valueToHtml(value),
    name: name,
    disabled: disabled,
    tabIndex: -1
  }), label ? /*#__PURE__*/React.createElement("div", {
    className: styles['label-wrapper']
  }, /*#__PURE__*/React.createElement("div", {
    className: styles['label']
  }, label), Array.isArray(value) && !!value.length && /*#__PURE__*/React.createElement("span", {
    className: styles['count']
  }, value.length)) : /*#__PURE__*/React.createElement("div", {
    className: styles['placeholder']
  }, placeholder || title));
});
function hasValue(value) {
  if (Array.isArray(value)) {
    return !!value.length;
  }
  return value !== null && value !== undefined;
}
function valueToHtml(value) {
  if (Array.isArray(value)) {
    return value.join(',');
  }
  if (value !== null && value !== undefined) {
    return String(value);
  }
  return;
}